'use strict';

angular.module('personModule', [
    'gov.filters',
    'gov.services',
    'gov.directives'
]);

/**
 * @typedef {object} Person
 *
 * @property {date}   ContractEndDate
 * @property {string} DepartmentBudgetCode
 * @property {date}   DepartureDate
 * @property {string} DisplayName
 * @property {string} EmployeeDepartmentCode
 * @property {string} EmployeeDepartmentEN
 * @property {string} EmployeeDepartmentFR
 * @property {string} EmployeeEmail
 * @property {string} EmployeeFirm
 * @property {string} EmployeeFirstName
 * @property {string} EmployeeLastName
 * @property {string} EmployeeLogin
 * @property {number} EmployeeNumber
 * @property {string} EmployeePositionNumber
 * @property {string} EmployeePositionEN
 * @property {string} EmployeePositionFR
 * @property {number} EmployeeSupervisorID
 * @property {string} EmployeeSupervisor
 * @property {string} EmployeeType
 * @property {string} EmployeeTypeFR
 * @property {string} Gender
 * @property {date}   HireDate
 * @property {number} IAMEmployeeID
 * @property {string} IamPhone
 * @property {string} IamOffice
 * @property {number} ItemPersonID
 * @property {string} Language
 * @property {string} LanguageDetails
 * @property {number} PSPDepartmentID
 * @property {number} PSPEmployeeID
 * @property {number} PSPEmployeeSupervisorID
 * @property {number} PSPEmployeeTypeID
 * @property {string} SearchDisplayName
 * @property {string} UrlImage
 */